const header = [
  {
    name: 'uploadFileName',
    label: 'Upload File Name',
    type: 'text',
    maxLength: 100,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'downloadFileName',
    label: 'Download File Name',
    type: 'text',
    maxLength: 100,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'message',
    label: 'Message',
    type: 'text',
    maxLength: 100,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'status',
    label: 'Process Status',
    type: 'text',
    maxLength: 10,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'createdDate',
    label: 'Created Time',
    type: 'date',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'completedDate',
    label: 'Completed Time',
    type: 'date',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'createdUser',
    label: 'User',
    type: 'text',
    maxLength: 20,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
];

export {
  header
};
